import api from "./api";

// 首页弹窗配置列表页
export const fetchList = params => {
  return api("post", `/v1/management/home-pop-up-config/list`, params);
};

// 新增
export const add = params => {
  return api("post", `/v1/management/home-pop-up-config/add`, params);
};

// 编辑
export const edit = params => {
  return api("post", `/v1/management/home-pop-up-config/edit`, params);
};

// 删除
export const del = params => {
  return api("delete", `/v1/management/home-pop-up-config/${params}`);
};

// 发布
export const publish = params => {
  return api("put", `/v1/management/home-pop-up-config/publish/${params}`);
};

// 下架
export const lowerShelf = params => {
  return api("put", `/v1/management/home-pop-up-config/lower-shelf/${params}`);
};

// 获取详情
export const getDetail = params => {
  return api("get", `/v1/management/home-pop-up-config/${params}`);
};
